module.exports = __webpack_public_path__ + "static/media/PlusIconWhite.36c7a613.svg";